import CustomHead from 'components/common/HeadMeta/HeadMeta'
import Template from 'components/download-completed'
import useLocalStorage from 'hooks/useLocalStorage'

const DownloadCompleted: React.FC = () => {
  const fromCorrectFormPage = useLocalStorage('refDownloadAIDrivenDevelopmentPage')

  return (
    <>
      {fromCorrectFormPage && (
        <CustomHead
          keyword={'AI駆動開発 人材不足 開発コスト削減 DX モダナイゼーション AI活用'}
          image={'https://www.i3design.jp/ogp_logo.png'}
          url={'https://www.i3design.jp/download/ai-driven-development/done/'}
          title="ご入力いただきありがとうございます | 経営者が押さえておくべきAI駆動開発ハンドブック | 資料ダウンロード | i3DESIGN アイスリーデザイン"
          description="ご入力いただいたメールアドレス宛に資料ダウンロード用URLを送付いたしました。メールをご確認いただき、資料をダウンロードしてください。"
          noindexNofollow={true}
        />
      )}
      <Template />
    </>
  )
}

export default DownloadCompleted
